module.exports = __webpack_public_path__ + "img/pocket-11_jp.705ef92.jpg";